import React, { PropsWithChildren, useCallback } from 'react';
import { ErrorMessage, FieldProps } from 'formik';
import { FileDrop } from './FileDrop';
import { InputError } from '../Atoms';

interface FormFileDropProps extends FieldProps {
  className?: string;
  documentDisplayClass?: string;
  disabled?: boolean;
}

function FormFileDrop({
  className,
  documentDisplayClass,
  disabled,
  field,
  form,
}: PropsWithChildren<FormFileDropProps>): React.ReactElement {
  const handleFileChange = useCallback(
    (file: File | null) => {
      form.setFieldValue(field.name, file);
    },
    [form, field.name]
  );

  return (
    <div className={className}>
      <FileDrop
        file={field.value}
        onFileChange={handleFileChange}
        name={field.name}
        documentDisplayClass={documentDisplayClass}
      />
      {!disabled && <ErrorMessage name={field.name} component={InputError} />}
    </div>
  );
}

export default FormFileDrop;
